<template>
  <div class="bodyy">
    <div class="main01_bg">
      <div class="main01 p-3">
        <div class="container text-center p-2" style="color:#ffffff; font-weight: bold;">
          <img src="../assets/LOGO/3A.png" alt="" width="100%">
          <img src="../assets/TW/img/tit.png" alt="" width="100%">
          <!-- <button type="button" class="btn p-2" -->
          <!-- style="background: linear-gradient(92deg,#e4ca9d 18%,#dcb062)!important;border-radius:20px;box-shadow: 0 0 10px rgb(245 242 242 / 82%); width:40%; padding: 8px;color: #ffff; font-size: 1.2rem;font-weight: bold;">活動詳情</button> -->

        </div>
      </div>
    </div>
    <!-- <div class="title2_bg">
            <h5 class="text-center tit_text">OFA GIRLS GAMING TUTORIAL</h5>
        </div> -->
    <div class="main02">
      <div class="container">
        <div class="row pb-2">
          <div class="card col-md-3 text-center tit2">

            <img src="../assets/TW/img/pro_tit.png" class="card-img-top" alt="...">
          </div>
          <div class="card col-md-3 text-center">

            <img src="../assets/TW/img/step1_img.png" class="card-img-top" alt="...">
          </div>
          <div class="card col-md-3 text-center">

            <img src="../assets/TW/img/step2_img.png" class="card-img-top" alt="...">
          </div>
          <div class="card col-md-3 text-center">

            <img src="../assets/TW/img/step3_img.png" class="card-img-top" alt="...">
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="title3_bg">
            <h5 class="text-center tit_text" style="color: #fff;">LATEST PROMOTION</h5>
        </div> -->

    <div>
      <div class="container text-center">
        <div class="row">
          <div class="col-md-6">
            <img src="../assets/TW/img/top01.png" alt="" width="100%">
          </div>
          <div class="col-md-6">
            <img src="../assets/TW/img/top01_car.png" alt="" width="100%">
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <img src="../assets/TW/img/top02.png" alt="" width="100%">
          </div>
          <div class="col-md-6">
            <img src="../assets/TW/img/top03.png" alt="" width="100%">
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <img src="../assets/TW/img/top04.png" alt="" width="100%">
          </div>
          <div class="col-md-6">
            <img src="../assets/TW/img/top05.png" alt="" width="100%">
          </div>
        </div>
      </div>


      <div class="main02">
        <div class="container">
          <div class="row">
            <div class="card col-md-2 text-center tit2">
              <!-- <p class="bouns-text" style="font-size: 4rem;
                                font-weight: bold;margin-bottom: 0rem; color: #9F6F1D;">獎金</p> -->
              <img src="../assets/TW/img/brouns.png" alt="" style="margin-top: 1.5rem;margin-bottom: 1.5rem;">
            </div>
            <div class="card col-md-2 text-center">
              <p style="font-size: 2.8rem;font-weight: bold;margin-bottom: 0rem;margin-top: 1.5rem;">6獎
                1688</p>
              <p style="margin-bottom: 0.5rem;margin-top: 0.5rem;">(10位)</p>
            </div>
            <div class="card col-md-2 text-center">
              <p style="font-size: 2.8rem;font-weight: bold;margin-bottom: 0rem;margin-top: 1.5rem;">7獎
                168</p>
              <p style="margin-bottom: 0.5rem;margin-top: 0.5rem;">(20位)</p>
            </div>
            <div class="card col-md-2 text-center">
              <p style="font-size: 2.8rem;font-weight: bold;margin-bottom: 0rem;margin-top: 1.5rem;">8獎 88
              </p>
              <p style="margin-bottom: 0.5rem;margin-top: 0.5rem;">(50位)</p>
            </div>
            <div class="card col-md-2 text-center">
              <p style="font-size: 2.8rem;font-weight: bold;margin-bottom: 0rem;margin-top: 1.5rem;">9獎 38
              </p>
              <p style="margin-bottom: 0.5rem;margin-top: 0.5rem;">(100位)</p>
            </div>
            <div class="card col-md-2 text-center">
              <p style="font-size: 2.8rem;font-weight: bold;margin-bottom: 0rem;margin-top: 1.5rem;">10獎 8
              </p>
              <p style="margin-bottom: 0.5rem;margin-top: 0.5rem;">(無上限)</p>
            </div>
          </div>
        </div>
      </div>

      <div class="m-3">
        <div class="container text-center" style="color: #ffffff;">
          <div class="row">
            <div class="col-md-6">
              <h3 class="mt-3">{{ $t('turn.account') }}：{{ this.userInformationData.user }}</h3>
            </div>
            <div class="col-md-6">
              <h3 class="mt-3">{{ $t('turn.count') }}：{{ this.count }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="container text-center">
          <div class="row">
            <!-- Modal -->
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
              aria-hidden="true" :class="{ show, 'd-block': active }">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <!-- <h1 class="modal-title fs-5" id="exampleModalLabel">恭喜您中獎!</h1> -->

                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                  </div>
                  <div class="modal-body">
                    <p style="font-size: 2rem; font-weight: bold; margin-bottom: 1rem; color: #c29a2b;">
                      {{ msg }}</p>
                    <p style="font-size: 2rem; font-weight: bold; margin-bottom: 1rem; color: #c29a2b;">
                      {{ msg2 }}</p>
                    <button style="text-align:center;" type="button" class="btn btn-primary" data-dismiss="modal"
                      aria-label="Close" @click="active = false">{{ $t('button.confirm') }}</button>
                  </div>
                  <div class="modal-footer">
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="turntable-bg mt-3" data-bs-toggle="modal" data-bs-target="#exampleModal">
                <div class="pointer" v-show="unlock"><img src="../assets/TW/img/pointer.png" alt="pointer"
                    @click="onClickRotate" style="width:100%;height:100%;">
                </div>
                <div class="rotate" :style="`transform: rotate(${wheelDeg}deg)`"><img id="rotate"
                    src="../assets/TW/img/turntable.png" alt="turntable" style="width: 100%; height: 100%;">
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mt-3">
                <table class="table table-bordered text-center"
                  style="border-radius: 20px;line-height: 2;background: linear-gradient(to bottom, #FFF4C8,#FCDE7C,#FFFAEE, #FFE979,#603515,#9F6F1D,#DCC35E); border: 5px solid #322fd000;">
                  <thead class="striped-tit">
                    <tr class="text-white" style="font-weight: bold;">
                      <th scope="col">{{ $t('winningRecord.winningTime') }}</th>
                      <th scope="col">{{ $t('winningRecord.award') }}</th>
                      <th scope="col">{{ $t('winningRecord.status') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="striped-1" v-for="data in winningData" :key="data.id">
                      <th scope="row">{{ data.drawTime }}</th>
                      <td>{{ data.award }}</td>
                      <td :style="activation(data.status)">{{ data.status }}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="mt-3">
                <button type="button" class="btn btn-secondary" style="color: #fff;" v-if="currentPage > 1"
                  @click="nextPage(-1)">{{ $t('winningRecord.previousPage') }}</button>
                <span style="color: #fff;"> {{ $t('winningRecord.page', { page: currentPage }) }}</span>
                <button type="button" class="btn btn-secondary" style="color: #fff;" v-if="nextPageVisable"
                  @click="nextPage(1)">{{ $t('winningRecord.nextPage') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-3">
        <div class="container text-center">
          <div class="row">
            <div class="col">
              <img v-for="logo in footerlogo"  v-bind:key="logo" :src="'./file/image/' + $route.query.p + '/' + logo + '.png'"/>
            </div>
          </div>
        </div>
      </div>
      <div class="m-3">
        <div class="container text-center" style="color:#686868;">
          Copyright© 2021 Big Master All Rights Reserved
        </div>
      </div>
      <div class="ui-gotop">
        <a :href=backUrl>
          <img src="../assets/TW/img/home.svg" width="30px"></a>
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui';

export default {
  name: "index",
  data() {
    return {
      //
      userInformationData: {
        user: "",
        token: "",
        platform: "",
        peid: ""
      },
      //get user
      result: '',
      //getUserReport
      count: null,
      start: 'turnplate',
      awardListMsg: [],
      list: 0,
      awardsSize: 0,
      msg: '',
      msg2: '',
      show: false,
      unlock: true,
      active: false,
      freeze: false,
      rolling: false,
      wheelDeg: 0,
      awardsListForm: [],
      winningData: [],
      file: 'award0',
      showFile: true,
      button_disabled: false,
      dialogTableVisible: false,
      currentPage: 1,
      nextPageVisable: false,
      total: 0,
      page_size: 10,
      user: '',
      token: '',
      backUrl: '',
      footerlogo: []
    };
  },
  computed: {
    activation() {
      return (istatus) => {
        if (istatus == this.$t('turn.payed')) {
          return { 'color': 'red' }
        }
      }
    }
  },
  created() {
    // this.switchLang()
    this.getEventsTime(this.$route.query.peid)
    this.checkUserToken(this.$route.query.user, this.$route.query.token, this.$route.query.p, this.$route.query.peid)
    // this.getUserReport()
    this.getMemberReport()
    this.getAwardsList()
    this.getWinningRecord(1)
  },
  mounted() {

  },
  methods: {
    getEventsTime(peid) {
      let postData = {
        PEid: peid
      }
      fetch('/api/getEventsTime',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          this.backUrl = res.data.BackUrl
          this.footerlogo = JSON.parse(res.data.Footerlogo)

          this.startTime = res.data.StartTime.split(' ')
          let st = this.startTime[0].substring(0, 4) + "年" + this.startTime[0].substring(5, 7) + "月" + this.startTime[0].substring(8, 10) + "日"
          this.startTime[0] = st
          this.endTime = res.data.EndTime.split(' ')
          let et = this.endTime[0].substring(0, 4) + "年" + this.endTime[0].substring(5, 7) + "月" + this.endTime[0].substring(8, 10) + "日"
          this.endTime[0] = et
        })
    },
    switchLang() {
      if (this.$route.query.p == 18 || this.$route.query.p == 168) {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'zh-tw'
      }
    },
    checkUserToken(user, token, platform, peid) {
      this.userInformationData.user = user
      this.userInformationData.token = token
      this.userInformationData.platform = platform
      this.userInformationData.peid = peid
    },
    nextPage(number) {
      this.currentPage = this.currentPage + number
      this.getWinningRecord(this.currentPage)
    },

    //計算獎項的總數
    async getAwardsList() {
      let postData = {
        PEid: this.userInformationData.peid
      }
      await fetch('/api/getEventsAwardsList',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          for (var i = 0; i < res.data.length; i++) {
            this.awardsListForm[i] = this.$t('awards.' + i)
            // this.awardsListForm[i] = res.data[i].award
          }
          this.awardsSize = res.data.length
        })
    },

    async getWinning() {
      this.rolling = true;
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        Platform: this.userInformationData.platform,
        PEid: this.userInformationData.peid
      }
      await fetch('/api/drawEvents',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.data != 404) {
            this.roll(res.data);
          } else {
            this.$message.error(this.$t('turn.' + res.data));
            this.rolling = false;
          }
        })
    },

    async getWinningRecord(page) {
      // let loadingInstance = Loading.service({ background: 'rgba(0, 0, 0, 0.6)' });
      this.dialogTableVisible = true
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        PEid: this.userInformationData.peid,
        Platform: this.userInformationData.platform,
        pageNum: page - 1
      }
      await fetch('/api/getEventsWinning',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.data.length > 0 && res.code == '0') {
            for (let index = 0; index < res.data.length; index++) {
              res.data[index].drawTime = this.formatDate(res.data[index].drawTime)
              // res.data[index].award = this.$t('awards.' + res.data[index].award)
              res.data[index].award = this.awardsListForm[res.data[index].award]
              if (res.data[index].status == "0") {
                res.data[index].status = this.$t('turn.unpay')
              } else {
                res.data[index].status = this.$t('turn.payed')
              }
            }
            this.total = res.total
            let total_count = this.total / (page * 10)
            if (total_count > 1) {
              this.nextPageVisable = true
            } else {
              this.nextPageVisable = false
            }
            this.winningData = res.data
          }
          // loadingInstance.close();
        })
    },

    async getMemberReport() {
      let loadingInstance = Loading.service({ background: 'rgba(0, 0, 0, 0.6)' });
      let postData = {
        User: this.userInformationData.user,
        Token: this.userInformationData.token,
        Platform: this.userInformationData.platform,
        PEid: this.userInformationData.peid
      }
      await fetch('/api/getUserInfo',
        { method: "POST", body: JSON.stringify(postData) }).then(res => res.json()).then(res => {
          if (res.code == 0) {
            if (res.data) {
              this.count = Math.floor(res.data.count)
            }
          } else if (res.code == 1) {//活動未開始
            this.show = true
            this.active = true
            let arr = res.msg.split(' ');
            this.msg = res.data + this.$t('turn.' + arr[0])
            this.msg2 = this.$t('turn.' + arr[1])
            this.unlock = false
            this.count = 0
          } else if (res.code == 2) {//活動已結束
            this.show = true
            this.active = true
            let arr = res.msg.split(' ');
            this.msg = this.$t('turn.' + arr[0])
            this.msg2 = this.$t('turn.' + arr[1])
            this.unlock = false
            this.count = 0
          } else {
            this.$message.error(this.$t('turn.' + res.data) + this.$t('turn.contact'));
            this.count = 0
            this.unlock = false
            this.count = 0
          }
          loadingInstance.close();
        })
    },

    onClickRotate() {
      // this.button_disabled = true
      // this.show = false //會清空中獎訊息欄
      //如果次數為0 不得抽獎
      if (this.count === 0 || this.count === null) {
        this.show = true
        this.active = true
        this.msg = this.$t('turn.zero')
        // this.$message.error('抽獎次數為0');
        // 如果尚在抽獎中不執行任何動作
      } else {
        if (this.rolling) {
          this.show = true
          this.active = true
          this.msg = this.$t('turn.drawing')
          return;
        }
        this.getWinning()
      }
    },

    roll(result) {
      var prize = 1
      switch (result) {
        case 0:
          prize = 10
          break;
        case 1:
          prize = 6
          break;
        case 2:
          prize = 8
          break;
        case 3:
          prize = 4
          break;
        case 4:
          prize = 2
          break;
        case 5:
          prize = 7
          break;
        case 6:
          prize = 3
          break;
        case 7:
          prize = 9
          break;
        case 8:
          prize = 5
          break;
        case 9:
          prize = 1
          break;
        default:
          break;
      }

      this.button_disabled = true
      const { wheelDeg, awardsListForm } = this;
      this.wheelDeg =
        wheelDeg -
        wheelDeg % 360 +
        6 * 360 +
        (360 - 360 / this.awardsSize * prize);

      setTimeout(() => {
        this.rolling = false;
        this.msg = this.$t('turn.congratulations') + awardsListForm[result];
        this.show = true
        this.active = true
        this.count = this.count - 1

        this.list = this.list + 1
        this.file = 'award' + result
        this.showFile = true
        this.button_disabled = false
        this.currentPage = 1
        this.getWinningRecord(this.currentPage)
      }, 4200);

    },
    formatDate(value) {
      value = parseInt(value) * 1000
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  watch: {
    prizeNumber() {
      this.freeze = true;
      this.wheelDeg = 0;

      setTimeout(() => {
        this.freeze = false;
      }, 0);
    }
  }
};


</script>


<style scoped>
@import '../assets/TW/css/demo.css';
@import '../assets/TW/css/style.css';
@import '../assets/TW/css/bootstrap.css';

.rotate {
  border-radius: 1000px;
  overflow: hidden;
  transition: transform 4s ease-in-out;
}

.quan {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0px;
  z-index: 99;
  display: none;
}

.quan1 {
  width: 300px;
  height: 200px;
  background: #fff;
  margin: 0 auto;
  margin-top: 300px;
  border-radius: 10px;
  border: 4px solid #666;
}

.qian2 {
  float: left;
  height: 50px;
  width: 196px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  margin-top: 50px;
  background: #fff;
  border: 2px solid #fff100;
  margin-left: 50px;
}

.queding {
  float: left;
  width: 70px;
  height: 24px;
  background: #fff;
  border: 2px solid #ccc;
  border-radius: 5px;
  margin-top: 50px;
  margin-left: 115px;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
}

.dis {
  color: #000;
  font-size: 100px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  margin-left: -90px;
  top: 100px;
  line-height: 30px;
}

.xianjin {
  width: 280px;
  height: 50px;
  background: #fff;
  position: absolute;
  border-radius: 10px;
  top: 248px;
  left: 200px;
  line-height: 50px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/luckyDraw.vue